import React, { ReactNode } from "react";
import styled from "styled-components";
import { Icon, iconName } from "../icons/Icons";
import { colors } from "../colors/color";

export const PillWrapper = styled.div`
    display:flex;
    flex-wrap: wrap;
    gap:10px;
`;

type PillProps = {
    identifier:string,
    children:ReactNode,
    variant?:'default' | 'selected',
    button?:{
        icon:iconName,
        onClick:(identifier?:string)=>void
    },
    verticalPadding?:number,
    horizontalPadding?:number,
    fontSize?:string
};
export function Pill(props:PillProps): JSX.Element
{
    // Not used currently
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [buttonHover, setButtonHover] = React.useState(false);

    return (
        <PillContainer 
            verticalPadding={props.verticalPadding === undefined ?  2 : props.verticalPadding} 
            horizontalPadding={props.horizontalPadding === undefined ?  2 : props.horizontalPadding}
            fontSize={props.fontSize || '14px'}
            selected={props.variant==='selected'}> 
            
            <div style={{display:'flex', justifyContent:'center', padding:`0px ${props.button ? '0px' : '8px'} 0px 8px`}}>
                {props.children}
            </div>

            {props.button &&
                <PillButton
                    onMouseEnter={() => setButtonHover(true)}
                    onMouseLeave={() => setButtonHover(false)}
                    hover={buttonHover}
                    selected={props.variant==='selected'}
                    onClick={() => props.button.onClick(props.identifier)}>
                    <Icon size="xx-small" name={props.button.icon} />
                </PillButton>
            }
            
        </PillContainer>
    );
}

const PillContainer = styled.div<{selected:boolean, verticalPadding:number, horizontalPadding:number, fontSize:string}>`
    display:inline-flex;
    min-width: 40px;
    justify-content: center;
    align-items: center;
    padding: ${props => `${props.verticalPadding}px ${props.horizontalPadding}px`};
    border-radius: 16px;
    border: 1px solid ${colors.pill.border};
    background-color:${props => {
        if(props.selected)
            return colors.pill.backgroundSelected;
        else
            return colors.pill.background;
    }};
    
    font-family: "Noto Sans", sans-serif;
    font-size: ${props => props.fontSize};
    font-weight: 400;
    line-height: 20px;

    color:${props => getColor(props.selected)};
`;

const PillButton = styled.button<{hover:boolean, selected:boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border:none; 
    cursor:${props => props.hover ? 'pointer' : 'default'};
    & svg{
        fill:${props => getColor(props.selected)};
    }
`;

function getColor(selected:boolean)
{
    if(selected)
        return colors.pill.colorSelected;

    return colors.pill.color;
}